export default [
  {
    path: ':path(usages.*)?',
    name: 'inventory.usages',
    beforeEnter: (to, from, next) => {
      // :path(usages.*)? path doesn't add usages to url so it needs to be added manually
      // this change in path is needed to handle url in more elastic way for Inventory micro-frontend
      if (!to.path.includes('inventory/usages')) {
        return next({
          path: to.path + (to.path.endsWith('/') ? '' : '/') + 'usages',
          query: to.query,
          hash: to.hash,
        })
      }

      next()
    },
    component: () => import('@/views/business/inventory/usages/iframe-service.vue'),
  },
]
